/**
 * Calculate ports layout angles based on element count
 * @param {string} type - node type (e.g. 'condition', 'user-choice')
 * @param {Array} elements - array of elements
 * @returns {{ angle: number, step: number }}
 */
export function calculatePortsLayout(type, elements) {
    //sst: add 1 for counting also failure port (condition node)
    const length = type === 'condition' ? elements.length + 1 : elements.length;

    let angle = 0;
    let step;
    switch (length) {
        case 2:
            step = 180;
            break;
        case 3:
            step = 90;
            break;
        case 4:
            step = 60;
            break;
        case 5:
            step = 45;
            break;
        case 6:
            step = 45;
            angle = -45;
            break;
        case 7:
            step = 45;
            angle = -45;
            break;
        case 8:
            step = 39;
            angle = -45;
            break;
        case 9:
            step = 33;
            angle = -45;
            break;
        default:
            step = 30;
            angle = -45;
            break;
    }

    return {
        angle: angle,
        step: step
    };
}
